import React from 'react';
import { CellProps } from 'react-table';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import classNames from 'classnames';
import styles from '../assets/provider-actions.module.scss';
import { IProvider } from 'src/types/provider';
import user from '../../../../../../../services/user-auth';
import UserRole from '../../../../../../../enumerables/user-role';

const ProviderActionsColumn: React.FunctionComponent<CellProps<IProvider>> = ({
    cell: {
        row: { original },
    },
}: CellProps<IProvider>) => {
    if (!user.getRoles().includes(UserRole.ROLE_ADMIN)) {
        return null;
    }
    return (
        <div className={classNames(styles.actions)}>
            <Link to={Router.generate(routes.PROVIDER_ANALYTICS_EDIT, { id: original.id })} className="btn btn-info">
                <FontAwesomeIcon icon={faSearch} />
            </Link>
        </div>
    );
};

export default ProviderActionsColumn;
